import { Component, Input, signal, ViewChild, WritableSignal } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { Table, TableModule } from 'primeng/table';
import { ametadatatreetable, atreetableoptions } from '../../domain/a-treetable.interface';
import { aButtonsCaption, aFuncionalButtons } from '../../../a-table/domain/a.table.interface';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SelectModule } from 'primeng/select';
import { dropdownItems, UtilService } from 'src/app/services/util.service';
import { TooltipModule } from 'primeng/tooltip';
import { CheckboxChangeEvent, CheckboxModule } from 'primeng/checkbox';
import { ConfirmationService, FilterMetadata, MessageService } from 'primeng/api';
import { DatePickerModule } from 'primeng/datepicker';
import { InputTextModule } from 'primeng/inputtext';
import { InputNumberModule } from 'primeng/inputnumber';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { TextareaModule } from 'primeng/textarea';

@Component({
  selector: 'app-a-treetable',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ButtonModule,
    TableModule,
    SelectModule,
    TooltipModule,
    CheckboxModule,
    DatePickerModule,
    InputTextModule,
    InputNumberModule,
    ConfirmPopupModule,
    TextareaModule
  ],
  templateUrl: './a-treetable.component.html',
  styleUrl: './a-treetable.component.css'
})
export class ATreetableComponent {

  constructor(
    private readonly servMessage: MessageService,
    private readonly servConfirmation: ConfirmationService,
    public readonly util: UtilService
  ) {

    console.log(this.listaSelectByType)
    // this.dataTable = this.dataTable.map((r, i) => ({ ...r, codeinterno: i, statustable: r.statustable ?? "E", checked: false }))
  }

  @ViewChild('dt1') table: Table
  @Input() dataTable: any[] = [];                      // Datos de la tabla

  @Input() metadataTable: ametadatatreetable[] = []           // Estructura de la tabla padre 
  @Input() metadataTableChildren: ametadatatreetable[] = []   // Estructura de la tabla hijo

  @Input() stripedRows: boolean = false           // Intercala lineas visualmente una blanca una gris
  @Input() dataKey: string                        // Key que idintifica el codigo de la informacion
  @Input() editMode: "row" | "cell" = "row"       // Tipo de edit por fila o todos habilitados

  @Input() addRowFather: boolean = false
  @Input() addRowChildren: boolean = false

  @Input() editModeFather: "row" | "cell" | "" = ""
  @Input() editModeChildren: "row" | "cell" | "" = ""

  @Input() buttonCaption: aButtonsCaption[] = []  // Lista de botones para el caption
  @Input() deleteMode: "row" | "list" | "" = ""   // Forma de eliminar registros por fila o los que selecciono
  @Input() addRow: boolean = false                // Habilita un boton para agregar mas datos a la tabla
  // @Input() deleteChildrenRow: boolean = false
  // @Input() editChildrenMode: "row" | "cell" | "" = ""
  @Input() saveChangesFunction: (row: any) => void

  @Input() funcionalButtonsFather: aFuncionalButtons[] = []
  @Input() funcionalButtonsChildren: aFuncionalButtons[] = []

  @Input() deleteRowChildren: boolean = false
  // @Input() addRowChildren: boolean = false
  @Input() editRow: boolean = false
  @Input() editRowChildren: boolean = false
  @Input() styleRow: (row: any) => { [key: string]: string } = () => ({});

  @Input() optionTable: atreetableoptions
  @Input() listaSelectByType: { [key1: number]: { [key2: number]: dropdownItems[] } } = {};
  @Input() customLeyendasHex: { color?: string; texto?: string }[] = [];
  @Input() btnResetFiltros: boolean = false;
  @Input() exportDataCsv: boolean = false;
  @Input() footerTotalFields: string[] = [];
  messageException: string = ""
  @Input() rows: any[] = [30, 50, 70]
  footer: boolean = true;
  @Input() scrollHeight: string = '92%'//'480px'
  @Input() viewCheck: boolean = false
  @Input() viewCheckChildren: boolean = false

  @Input() functionOnInit: () => void
  @Input() showFilters: boolean = false;
  cadenaFiltrosConsolidada: WritableSignal<string> = signal('');
  cadenaFiltrosHijo: WritableSignal<string> = signal('');

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.functionOnInit?.()
  }

  expandedRows = {};
  expandAll() {
    this.expandedRows = this.dataTable.reduce((acc, p) => (acc[p.codeinterno] = true) && acc, {});
  }

  collapseAll() {
    this.expandedRows = {};
  }

  onChangeSelect(event, row: any, lista: any[], field: string) {
    console.log("SELECT", lista)
    try {

      const item = lista.find(r => r.value === event.value)

      if (item) {

        row[field] = item.label

        if (row["statustable"] === "E") {
          row["statustable"] = "U"
        }

      } else if (event.value === null) {

        row[field] = null
        if (row["statustable"] === "E") {
          row["statustable"] = "U"
        }

      }
    } catch (error) {
      this.messageException = error
    }
  }

  onChangeInput(event, row: any) {
    try {
      if (event) {
        // const row = this.dataTable.find(r => r.codeinterno === codigo)
        if (row["statustable"] === "E") {
          row["statustable"] = "U"
        }
      }
    } catch (error) {
      this.messageException = error
    }
  }

  //#region Funciones de conversion

  convertDateFormat(fecha: any, formato: string) {

    if (!(fecha instanceof Date) || isNaN(fecha.getTime())) {
      return "";
    }

    fecha = new Date(fecha)

    const dia = String(fecha.getDate()).padStart(2, '0');
    const mes = String(fecha.getMonth() + 1).padStart(2, '0'); // getMonth() es base 0
    const anio = fecha.getFullYear();
    const horas = String(fecha.getHours()).padStart(2, '0');
    const minutos = String(fecha.getMinutes()).padStart(2, '0');

    switch (formato) {
      case 'date':
        return `${dia}/${mes}/${anio}`;
      case 'datetime':
        return `${dia}/${mes}/${anio} ${horas}:${minutos}`;
      default:
        return "";
    }
  }

  //#endregion

  //#region CONSTANTES

  listMoneda: dropdownItems[] = [
    { label: "PEN", value: "001" },
    { label: "USD", value: "002" },
    { label: "EUR", value: "003" },
    { label: "POR", value: "004" },
    { label: "UNI", value: "005" }
  ]

  listUnidad: dropdownItems[] = [
    { label: "PEN", value: "001" },
    { label: "USD", value: "002" },
    { label: "EUR", value: "003" },
    { label: "UNI", value: "004" },
    { label: "POR", value: "005" }
  ]

  listUnidadMedida: dropdownItems[] = [
    { label: "KM", value: "001" },
    { label: "MTS", value: "002" },
    { label: "KL", value: "003" },
    { label: "MC", value: "004" },
    { label: "CM", value: "005" },
    { label: "M3", value: "006" },
    { label: "T", value: "007" }
  ]

  //#endregion

  functionClick(col: any, rowData: any) {
    try {
      const confirm = col.confirmFunction
      const func = col.function
      if (confirm) {

        this.servConfirmation.confirm({
          target: event.target as EventTarget,
          dismissableMask: false,
          message: '¿Desea continuar la operación?',
          header: 'Confirmación',
          closable: true,
          closeOnEscape: true,
          icon: 'pi pi-exclamation-triangle',
          rejectButtonProps: {
            label: 'Cancelar',
            severity: 'secondary',
            outlined: true,
          },
          acceptButtonProps: {
            label: 'Guardar',
          },
          accept: () => {
            func(rowData);
          },
          key: "cd"
          // reject: () => {
          //   this.messageService.add({
          //     severity: 'error',
          //     summary: 'Rejected',
          //     detail: 'You have rejected',
          //     life: 3000,
          //   });
          // },
        })

      } else {
        func(rowData);
      }
    } catch (error) {
      this.messageException = error
    }

  }


  clonedRow: { [s: string]: any } = {};
  onRowEditInit(row: any) {
    this.clonedRow[row.ctar_codigo as string] = { ...row };
  }

  onRowEditSave(row: any) {

    const originalRow = this.clonedRow[row.ctar_codigo as string];
    const hasChanges = !this.objectsAreEqual(originalRow, row);

    if (row.statustable !== 'I') {
      if (hasChanges) {
        row.statustable = 'U'
        this.servMessage.add({ severity: 'success', summary: 'Editar', detail: 'La fila se edito correctamente.' })
      } else {
        this.servMessage.add({ severity: 'error', summary: 'Editar', detail: 'No se detectaron cambios.' })
      }
    }


    delete this.clonedRow[row.ctar_codigo as string];

  }

  onRowEditCancel(row: any, index: number) {
    this.dataTable[index] = this.clonedRow[row.ctar_codigo as string];
    delete this.clonedRow[row.ctar_codigo as string];
  }

  viewInfo() {
    console.log(this.dataTable)
  }

  objectsAreEqual(obj1: any, obj2: any): boolean {
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) {
      return false;
    }

    for (const key of keys1) {
      if (obj1[key] !== obj2[key]) {
        return false;
      }
    }

    return true;
  }

  addEmptyRow(): void {
    try {
      const usedCodes = this.dataTable.map(row => row.codeinterno)

      let newCode = 0
      while (usedCodes.includes(newCode)) {
        newCode++
      }

      const baseStructure = this.dataTable[0] || {};
      const newRow: any = {}

      Object.keys(baseStructure).forEach(key => {
        newRow[key] = null
      });

      newRow.codeinterno = newCode
      newRow.statustable = 'I'
      newRow.checked = false

      // if (this.onAddEmptyRow) {
      //   this.onAddEmptyRow(newRow);
      // }

      newRow.metadata = this.dataTable[0].metadata
      newRow.detail = []

      this.dataTable.push(newRow)

      // this.addEmptyRowEvent.emit(newRow)

    } catch (error) {
      this.messageException = error
    }
  }

  //#region CHILDREN FUNCTIONS

  /**
   * Funcion para agregar un nuevo item a la fila principal
   * @param row - Fila a la cual se agregara el nuevo item
   */
  addEmptyChildrenRow(row): void {
    try {

      const usedCodes = row.detail?.map(row => row.codeinterno)

      // this.dataTable.map(row => row.codeinterno)

      let newCode = 0
      while (usedCodes && usedCodes.includes(newCode)) {
        newCode++
      }

      var baseStructure = row.detail?.[0] //|| {} //this.dataTable[0] || {};
      if (!baseStructure) {
        baseStructure = this.dataTable[0].detail[0] || {}
      }

      const newRow: any = {}

      Object.keys(baseStructure).forEach(key => {
        newRow[key] = null
      });

      newRow.codeinterno = newCode
      newRow.statustable = 'I'
      newRow.checked = false

      // if (this.onAddEmptyRow) {
      //   this.onAddEmptyRow(newRow);
      // }

      row.detail.push(newRow)

      // this.dataTable.push(newRow)
      // this.addEmptyRowEvent.emit(newRow)

    } catch (error) {
      this.messageException = error
    }
  }

  /**
  * Función para eliminar una fila nueva o cambia a estado D en una fila existente
  * 
  * @param row - fila hija a la que se modificara el estado
  */
  deleteChildrenRowByCode(row: any, rowChildren: any) {
    try {

      // const item = this.dataTable.find(r => r.codeinterno === row.codeinterno)

      if (rowChildren && (rowChildren.statustable === "E" || rowChildren && rowChildren.statustable === "U")) {
        rowChildren.statustable = "D"
        rowChildren.checked = false
      } else {

        row.detail = row.detail.filter(r => r.codeinterno !== rowChildren.codeinterno)

        // this.dataTable = this.dataTable.filter(r => r.codeinterno !== row.codeinterno)
      }

      // if (item && (item.statustable === "E" || item && item.statustable === "U")) {
      //   item.statustable = "D"
      //   item.checked = false
      // } else {
      //   this.dataTable = this.dataTable.filter(r => r.codeinterno !== row.codeinterno)
      // }

    } catch (error) {
      this.messageException = error
    }
  }

  //#endregion




  onChangeSelectCoin(event, row: any, lista: any[], field: string) {
    try {
      const item = lista.find(r => r.value === event.value)
      if (item) {
        // const row = this.dataTable.find(r => r.codeinterno === codigo)
        row[field] = item.value
        if (row["statustable"] === "E") {
          row["statustable"] = "U"
        }
      }
    } catch (error) {
      this.messageException = error
    }
  }

  getMonedaLabel(codigo: string): string {
    const moneda = this.listMoneda.find(r => r.value === codigo);
    return moneda ? moneda.label : '';
  }

  getUnidadLabel(codigo: string): string {
    const moneda = this.listUnidad.find(r => r.value === codigo);
    return moneda ? moneda.label : '';
  }

  getUnidadMedidaLabel(codigo: string): string {
    const moneda = this.listUnidadMedida.find(r => r.value === codigo);
    return moneda ? moneda.label : '';
  }

  validateRowChanges(row: any): boolean {

    if (['I', 'U', 'D'].includes(row.statustable)) {
      return false;
    }

    if (Array.isArray(row.detail)) {
      const hasChangesInDetail = row.detail.some(
        (r: any) => ['I', 'U', 'D'].includes(r.statustable)
      );
      if (hasChangesInDetail) {
        return false;
      }
    }

    return true;
  }

  checkAllStateFather: boolean = false
  checkAllStateChildren: { [code: number]: boolean } = {}
  /**
   * Funcion que evalua que todos los checks esten marcados para habilitar el "checkAllState"
   */
  onChangeListCheck() {
    try {

      // const allChecked = this.dataTable.every(row => row.checked === true);
      // this.checkAllStateFather = allChecked;

      // let allChecked = true;

      // this.dataTable.forEach(father => {
      //   const children = father.detail || [];

      //   const allChildrenChecked = children
      //     .filter((child: any) => child.statustable !== 'D')
      //     .every((child: any) => child.checked === true);

      //   const fatherChecked = father.statustable === 'D' ? true : father.checked === true;

      //   // Actualiza el estado de checkAllStateChildren por codeinterno
      //   this.checkAllStateChildren[father.codeinterno] = allChildrenChecked;

      //   if (!fatherChecked || !allChildrenChecked) {
      //     allChecked = false;
      //   }
      // });

      // this.checkAllStateFather = allChecked;

      this.dataTable.forEach(father => {
        const children = father.detail || [];
        const allChildrenChecked = children
          .filter((child: any) => child.statustable !== 'D')
          .every((child: any) => child.checked === true);

        this.checkAllStateChildren[father.codeinterno] = allChildrenChecked;
      });

      this.checkAllStateFather = this.dataTable
        .filter(father => father.statustable !== 'D')
        .every(father => father.checked === true);

    } catch (error) {
      this.messageException = error
    }
  }
  selectAll(event: any) {

    const wrapper = event.currentTarget as HTMLElement;
    if (!wrapper) return;

    const input = wrapper.querySelector('input') as HTMLInputElement;
    if (!input) return;

    event.preventDefault();   // 🔥 CLAVE
    input.focus();
    input.select();

  }
  /**
  * Funcion para marcar o desmacar todas las filas habiles
  * 
  * @param event - evento de checkbox para saber si es true o false
  */
  checkAll(event: CheckboxChangeEvent, row: any, type: "Father" | "Children"): void {
    try {

      const isChecked = event.checked

      if (type == "Father") {
        this.dataTable.forEach(r => { if (r.statustable !== 'D') { r.checked = isChecked } })
      } else {
        row.detail?.map(r => { if (r.statustable !== "D") { r.checked = isChecked } })
      }

    } catch (error) {
      this.messageException = error
    }
  }

  /**
  * Función para eliminar las filas seleccionadas
  * 
  * - Verificamos que existe al menos una fila seleccionada
  * - Ubicamos los codigo de las filas a actualizar a D y las que se eliminaran
  * - Actualizamos en base a la lista "codesToMarkDeleted"
  * - Eliminamos en base a la lista "codesToDelete"
  */
  deleteCheckList(row: any) {
    try {

      const noneSelected = row.detail.every(r => !r.checked)
      if (noneSelected) {
        this.servMessage.add({ severity: 'error', summary: 'Eliminar Filas', detail: 'Es necesario marcar al menos una fila.', life: 3000 });
        return
      }

      const codesToDelete: number[] = []
      const codesToMarkDeleted: number[] = []

      row.detail.forEach(r => {
        if (r.checked) {
          if (r.statustable === "E" || r.statustable === "U") {
            codesToMarkDeleted.push(r.codeinterno)
          } else {
            codesToDelete.push(r.codeinterno)
          }
        }
      })

      row.detail.forEach(r => {
        if (codesToMarkDeleted.includes(r.codeinterno)) {
          r.statustable = "D"
          r.checked = false
        }
      });

      row.detail = row.detail.filter(
        r => !codesToDelete.includes(r.codeinterno)
      );

    } catch (error) {
      this.messageException = error
    }
  }
  convertToDecimal(value: any, decimalPlaces: number = 2): string {
    const numberValue = parseFloat(value);
    if (isNaN(numberValue)) return '0.00';
    const fixedNumber = numberValue.toFixed(decimalPlaces);
    const [integerPart, decimalPart] = fixedNumber.split('.');
    const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return decimalPart ? `${formattedIntegerPart}.${decimalPart}` : formattedIntegerPart;
  }

  formatPorcentaje(value: any, decimales: number = 2): string {
    const numberValue = parseFloat(value);
    if (isNaN(numberValue)) return '0.00%';
    const fixedNumber = numberValue.toFixed(decimales);
    const [integerPart, decimalPart] = fixedNumber.split('.');
    const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return `${decimalPart ? `${formattedIntegerPart}.${decimalPart}` : formattedIntegerPart}%`;
  }

  getFooterTotal(field: string, type: string = 'int'): string {
    let total = 0;
    (this.table?.filteredValue || this.dataTable || []).forEach(r => {
      const valor = parseFloat(r[field]);
      total += !isNaN(valor) ? valor : 0;
    });
    if (type === 'porcentaje') return this.formatPorcentaje(total, 2);
    return type === 'decimal' ? this.convertToDecimal(total) : this.formatNumber(total, 'int');
  }

  export() {
    if (!this.dataTable || this.dataTable.length === 0) {
      console.warn('No hay datos para exportar.');
      return;
    }
    let nuevadata = [];
    this.dataTable.forEach(row => {
      const newItem = {};
      this.metadataTable.forEach(e => {
        newItem[e.header.title.toUpperCase()] = row[e.field.output];
      });
      nuevadata.push(newItem);
    });
    const data = [{ data: nuevadata, cabeceras: [] }];
    this.util.ExportarExcel(data, 'Reporte.xlsx', false);
  }

  checkLists: { [key: string]: any[] } = {}
  onChangeCheckList(event: any, row: any, col: any): void {
    const key = col.field.output
    if (!this.checkLists[key]) {
      this.checkLists[key] = []
    }

    if (event.checked) {
      this.checkLists[key].push(row)
    } else {
      this.checkLists[key] = this.checkLists[key].filter(item => item.index !== row.index)
    }
  }

  resetCheckList(colKey: string): void {
    this.checkLists[colKey] = []
  }
  formatNumber(value: any, type: string): string {
    if (type == 'percentage') {
      let valor = '0'
      if (isNaN(value)) {
        valor = '0 %'
      } else {
        valor = (value).toFixed(0) + ' %'
      }
      return valor
    }
    const numberValue = parseFloat(value);
    if (isNaN(numberValue)) return type === 'decimal' ? '0.00' : '0';
    let decimalPlaces = type === 'decimal' ? 2 : (Math.floor(numberValue) === numberValue ? 0 : 1);
    const fixedNumber = numberValue.toFixed(decimalPlaces);
    const [integerPart, decimalPart] = fixedNumber.split('.');
    const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return decimalPart ? `${formattedIntegerPart}.${decimalPart}` : formattedIntegerPart;
  }
  getDisabledSelectEdit(condicion: any, descripcion: any): boolean {
    if (condicion !== undefined || condicion != null) {
      if (descripcion !== undefined && descripcion == null) {
        if (String(condicion) === descripcion) {
          return true; // Deshabilitar si la condición es igual a la descripción
        } else {
          return false; // No deshabilitar si la condición no es igual a la descripción
        }
      } else {
        return condicion; // Usar el valor booleano de la condición directamente
      }
    } else {
      return false; // Por defecto, no deshabilitar
    }
  }
  getOperadorExpresion(matchMode: string, fieldName: string): string {
    const mode = matchMode.toLowerCase();

    const isDate = fieldName.includes('fecha') || fieldName.includes('date');
    const isNumber = fieldName.includes('costo') || fieldName.includes('profit') || fieldName.includes('venta') || fieldName.includes('dias');

    if (isDate) {
      switch (mode) {
        case 'dateis': return '=';
        case 'dateisnot': return '!=';
        case 'datebefore': return '<';
        case 'dateafter': return '>';
      }
    }

    if (isNumber) {
      switch (mode) {
        case 'equals': return '=';
        case 'notequals': return '!=';
        case 'lt': return '<';
        case 'lte': return '<=';
        case 'gt': return '>';
        case 'gte': return '>=';
      }
    }

    switch (mode) {
      case 'startswith': return 'EMPIEZA CON';
      case 'contains': return 'CONTIENE';
      case 'notcontains': return 'NO CONTIENE';
      case 'endswith': return 'TERMINA CON';
      case 'equals': return '=';
      case 'notequals': return '!=';
      default: return mode.toUpperCase();
    }
  }

  generarCadenaFiltro(filtros: FiltroPrimeNG, esHijo: boolean = false): string {
    const expresiones: string[] = [];
    const metadatos = esHijo ? this.metadataTableChildren : this.metadataTable;

    const obtenerTitle = (field: string): string => {
      let meta: any;

      if (esHijo) {
        for (const row of this.dataTable) {
          if (row.metadata) {
            meta = row.metadata.find(m => m.field.output === field || m.field.input === field);
            if (meta) break;
          }
        }
        if (!meta) meta = this.metadataTableChildren.find(m => m.field.output === field || m.field.input === field);
      } else {
        meta = this.metadataTable.find(m => m.field.output === field || m.field.input === field);
      }

      return meta ? meta.header?.title : field;
    };

    // 1. Añadir el Filtro Global 
    // const filtroGlobalRaw = filtros['global'] as FilterMetadata;
    // if (filtroGlobalRaw && filtroGlobalRaw.value !== null && filtroGlobalRaw.value !== '') {
    //   const globalMode = (filtroGlobalRaw.matchMode || 'CONTAINS').toUpperCase();
    //   expresiones.push(`(FILTRO GLOBAL: ${globalMode} '${filtroGlobalRaw.value}')`);
    // }

    // 2. Procesar Filtros por Columna
    for (const columna in filtros) {
      if (columna !== 'global') {
        const condiciones = filtros[columna] as FilterMetadata[];

        if (columna !== 'global') {
          const condiciones = filtros[columna] as FilterMetadata[];
          if (Array.isArray(condiciones)) {
            const titleColumna = obtenerTitle(columna);
            const filtrosColumnaActivos = condiciones
              .filter(condicion => condicion.value !== null && condicion.value !== '')
              .map(filtro => {
                const operador = this.getOperadorExpresion(filtro.matchMode, columna);
                let valorRepresentacion = filtro.value;

                if (valorRepresentacion instanceof Date) {
                  const fechaFormateada = this.util.formatearfecha(valorRepresentacion, 'yyyy-mm-dd');
                  valorRepresentacion = `'${fechaFormateada}'`;
                }
                else if (typeof valorRepresentacion === 'string') {
                  valorRepresentacion = `'${valorRepresentacion}'`;
                } else if (Array.isArray(valorRepresentacion)) {
                  valorRepresentacion = `(${valorRepresentacion.map(v => `'${v}'`).join(' O ')})`;
                  return `<b>[${titleColumna}]</b> ES IGUAL A UNO DE ${valorRepresentacion}`;
                }

                return `<b>[${titleColumna}]</b> ${operador} ${valorRepresentacion}`;
              });

            if (filtrosColumnaActivos.length > 0) {
              const operadorInterno = (condiciones[0].operator || 'and').toUpperCase();
              expresiones.push(`(${filtrosColumnaActivos.join(` ${operadorInterno} `)})`);
            }
          }
        }
      }
    }

    // 3. Concatenar todas las expresiones con " Y " (AND)
    return expresiones.length > 0 ? expresiones.join(" Y ") : "";
  }

  notificarCambioFiltros(): void {
    const filtrosActuales = this.table.filters;
    this.cadenaFiltrosConsolidada.set(this.generarCadenaFiltro(filtrosActuales));

    // console.log("--- 🔎 Cadena de Filtro Consolidada Actualizada 📝 ---");
    // console.log(this.cadenaFiltrosConsolidada());
    // console.log(this.table)
    // console.log("-------------------------------------------------------");
  }

  onTableFilter(event: any): void {
    this.notificarCambioFiltros();
  }

  onChildTableFilter(event: any): void {
    const filtrosHijo = event.filters;
    this.cadenaFiltrosHijo.set(this.generarCadenaFiltro(filtrosHijo, true));
  }

}

interface FiltroPrimeNG {
  [key: string]: FilterMetadata | FilterMetadata[];
  global?: { value: any, matchMode: string };
}
